/* eslint-disable react/prop-types */
import { PhoneCall } from "lucide-react";
import GlobalTitle from "../../components/shared/GlobalTitle";
import RoundedButton from "../../components/ui/RoundedButton";

const TalkToUs = ({ data }) => {
  return (
    <div className="lg:border-r-2 lg:border-dashed lg:border-primary lg:pr-8">
      <GlobalTitle title={data.title} />
      <div className="pb-5 lg:pb-10">
        <div className="grid justify-between grid-cols-2 mt-2">
          {data.offices?.map((office, idx) => (
            <div key={idx}>
              <h4 className="font-medium text-gray-800">
                {office.office_name}
              </h4>
              <ul className="pt-2 text-primary">
                {office.numbers?.map((num) => (
                  <li key={num} className="flex items-center gap-2">
                    <PhoneCall className="size-4" />
                    <a
                      href={`tel:${num}`}
                      className="text-gray-700 hover:underline"
                    >
                      {num}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <RoundedButton href="https://maps.app.goo.gl/Ngp6QDBBa21b7rmo6">
        Campus Maps and Directions
      </RoundedButton>
    </div>
  );
};

export default TalkToUs;
